import moment from "moment/moment";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import info from "../../../data/racines.json";
import { checkIfAllowedToRespond, isAllResponded, onCompleted, findNotResponded } from "../formHelper";
import FooterPagesNavigation from "../../../components/FooterPagesNavigation";

export default function QuestionRacines({}) {
  const navigate = useNavigate();
  const [reponses, setReponses] = useState(
    localStorage.getItem("reponses")
      ? JSON.parse(localStorage.getItem("reponses"))
      : [
          ...info.forms.map((form, group) =>
            form.questions.map((e, key) => {
              return {
                group: group,
                number: key,
                scoreGroup: e.group,
                score: undefined,
              };
            })
          ),
        ]
  );
  const [page, setPage] = useState(1);
  const hash = useLocation().hash;

  useEffect(() => {
    checkIfAllowedToRespond(1)
      .then()
      .catch((err) => navigate("/notAllowed"));
  }, []);

  useEffect(() => {
    setPage(parseInt(hash.split("#")[1]));
  }, [hash]);

  useEffect(() => {
    for (let index = 0; index < reponses[page - 1].length; index++) {
      const element = reponses[page - 1][index];
      if (element.score === undefined && index === 0) {
        break;
      } else if (element.score === undefined) {
        document.getElementById("card_" + page + "_" + index).scrollIntoView({ behavior: "smooth" });
        break;
      }
    }
  }, [page]);

  return (
    <>
      <div className="flex flex-col items-center p-4 mb-36 pt-14 space-y-5">
        <h1 className="text-3xl">{info.forms[page - 1].title}</h1>
        <p className="text-center text-palette-orange">
          Répondre à la question en glissant entre une valeur de 1 ({info.forms[page - 1].minLabel}) à 10 ({info.forms[page - 1].maxLabel}).
        </p>
        <div className="flex flex-col py-10 md:grid md:grid-cols-2 gap-5">
          {info.forms[page - 1].questions.map((question, key) => (
            <div key={question.message} id={"card_" + page + "_" + key} className="flex flex-col max-w-lg p-4 bg-white w-full shadow rounded-lg">
              <p className="text-xl flex-grow font-semibold">{question.message}</p>
              <div className="flex items-center justify-between mt-10 text-sm">
                <p className="w-full">{info.forms[page - 1].minLabel}</p>
                <p className={"w-full font-semibold text-center " + (reponses[page - 1][key].score !== undefined ? "" : "text-red-400")}>
                  {reponses[page - 1][key].score !== undefined ? Math.round(reponses[page - 1][key].score) : "Pas de reponse"}
                </p>
                <p className="w-full text-right">{info.forms[page - 1].maxLabel}</p>
              </div>
              <input
                type="range"
                value={reponses[page - 1][key].score}
                onChange={(e) => {
                  let modif = [...reponses];
                  modif[page - 1][key].score = e.target.valueAsNumber;
                  setReponses(modif);
                }}
                min="0"
                max="10"
                step="1"
                className="transparent h-4 md:h-2 w-full cursor-pointer appearance-none rounded-lg my-4 border-transparent bg-neutral-200"
                id={"range_" + page + "_" + key}
              />
            </div>
          ))}
        </div>
      </div>
      <FooterPagesNavigation
        pages={2}
        onEnd={() => onCompleted(reponses, navigate)}
        endDisable={!isAllResponded(reponses)}
        onClickDisable={() => findNotResponded(reponses, navigate)}
        textDisable="Réponses manquantes"
      />
    </>
  );
}
